module.exports = __webpack_public_path__ + "static/media/29FUNOV15.941f9774.jpg";